export default "__VITE_ASSET__CsFlu5nQ__"